import { Link } from "react-router-dom";
import React, { useEffect } from "react";
import Car from "../assets/img/shape/car.png";
import Line0 from "../assets/img/shape/line-1.png";
import Plane from "../assets/img/vector/hero-plane.png";
import heroImage from "../assets/img/bg/hero-1.jpg";

export default function HeroSection() {
  useEffect(() => {
    var mybutton = document.getElementById("scrtop");

    window.onscroll = function () {
      scrollFunction();
    };

    function scrollFunction() {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        mybutton.style.display = "block";
      } else {
        mybutton.style.display = "none";
      }
    }
  }, []);
  return (
    <div
      className="hero-area pos-rel bg-top-center"
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      <div class="hero-single">
        <div class="container">
          <div class="hero-wpr pos-rel">
            <div class="hero-shapes">
              <img src={Car} class="hero-car car-run" alt="no image" />
              <img src={Line0} alt="no image" />
              <img src={Plane} class="hero-plane-1 up-move" alt="no image" />
            </div>
            <div class="row g-5">
              <div class="col-xl-8">
                <div class="hero-content element-center">
                  <div class="hero-content-desc">
                    <span class="hero-sub-title mb-20">
                      <span class="hero-line"></span>
                      we're the best
                    </span>
                    <h2 class="hero-title">
                      Hallgord Cargo & <br /> Logistics
                    </h2>
                    <p class="mb-40">
                      Our professional competencies, availability of assets,
                      work quality, and financial intensity are unrivaled and
                      distinctively place the company to compete with
                      international companies. Committed to carrying out all
                      jobs, regardless of being complete or partial endeavors,
                      or supplying tools or services to those endeavors with the
                      utmost efficiency and effectiveness.
                      <br />
                      <br />
                      We make every effort to successfully provide end-to-end
                      solutions to customers through ingenuity, technology, and
                      investment. Our team strives to deliver the quality our
                      customers expect and deserve. Our goal is to become the
                      industry's leading logistics and supply chain service
                      provider in Erbil by delivering innovative, efficient, and
                      cost-effective solutions and achieving excellence in
                      serving our clients.
                    </p>
                    <div class="hero-btn">
                      <Link to="/tracking" className="btn-1 btn-md">
                        Track Your Cargo
                      </Link>
                      <Link
                        to="/contact"
                        className="btn-transparent btn-transparent-md"
                      >
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
